import { carouselData } from '@/mocks/homeData';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">编辑精选的深度专题报道</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group bg-background-100 border border-background-200 rounded-xl overflow-hidden hover:border-accent-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 bg-accent-500 text-white text-xs px-3 py-1 rounded-full font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-accent-700 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm font-medium text-accent-600">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}